@if (isVisible) {
  <div class="cookie-consent-banner" role="dialog" aria-modal="true" aria-label="Cookie consent options">
    <div class="cookie-consent-container">
      <div class="cookie-consent-content">
        <div class="cookie-consent-header">
          <i class="fa-solid fa-cookie" aria-hidden="true"></i>
          <h3>Cookie Consent</h3>
        </div>
        <p class="cookie-consent-message">
          Articix uses cookies and related technologies to understand how you use our website and to enhance your experience.
          We also use cookies for analytics and marketing purposes. Please review our
          <a routerLink="/cookie-policy" class="cookie-link">cookie policy</a> for more information.
        </p>
        <p class="cookie-consent-message" style="font-size: 0.75rem; margin-top: 8px;">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener" class="cookie-link">Privacy Policy</a> and
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener" class="cookie-link">Terms of Service</a> apply.
        </p>
        <div class="cookie-consent-types">
          <div class="cookie-type">
            <strong>Essential Cookies</strong>
            <p>Required for website functionality. Always enabled.</p>
          </div>
          <div class="cookie-type">
            <strong>Analytics Cookies</strong>
            <p>Help us understand how you use our website to improve performance.</p>
          </div>
          <div class="cookie-type">
            <strong>Marketing Cookies</strong>
            <p>Used to deliver targeted content and understand campaign effectiveness.</p>
          </div>
        </div>
      </div>
      <div class="cookie-consent-actions">
        <button class="btn btn-sm btn-outline-secondary" (click)="rejectAll()" aria-label="Reject non-essential cookies">Reject All</button>
        <button class="btn btn-sm btn-outline-secondary" (click)="acceptEssentialOnly()" aria-label="Accept essential cookies only">Accept Essential Only</button>
        <button class="btn btn-sm btn-brand-primary" (click)="acceptAllCookies()" aria-label="Accept all cookies">Accept All</button>
      </div>
    </div>
  </div>
}
